import axios from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { blueprintsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";

export interface SaveBlueprintDto {
  namespace: string;
  name: string;
  author: string;
  organization: string;
  description: string;
  root_node: unknown;
  dashboard_data: unknown;
  alarm_profiles: unknown;
}

export const saveBlueprint = async (dto: SaveBlueprintDto) => {
  const url = blueprintsUrlEnvVar();
  return axios({
    url: `${url}/api/v3/ns/${dto.namespace}/blueprints`,
    method: "POST",
    headers: buildAxiosAuthenticationHeaders(),
    data: {
      namespace: dto.namespace,
      name: dto.name,
      author: dto.author,
      organization: dto.organization,
      description: dto.description,
      root_node: dto.root_node,
      dashboard: dto.dashboard_data,
      alarm_profiles: dto.alarm_profiles,
    },
    validateStatus: (status) =>
      (status >= 200 && status < 300) || status === 422,
  })
    .then((response) => response.data)
    .then((data) => {
      if (data !== undefined) {
        return data;
      }
    })
    .catch((err) => {
      if (err?.response?.data?.message === "Refresh Token is expired") {
        navigateTo(Route.TOKENS_EXPIRED_ERROR);
      } else {
        navigateTo(Route.SERVER_ERROR);
      }
    });
};
